import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'WeployDesignLanguage/buttons/Button';

import {
  DASHBOARD_PATH,
  getInternalPath,
} from '../pathHelpers';

const StyledUnauthorizedWrapper = styled.div`
  margin: 0 auto;
  max-width: 600px;
  text-align: center;
`;

const StyledHeading = styled.h4`
  margin-top: ${props => props.theme.spacing[1]};
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const StyledDescription = styled.p`
  margin: 0 0 ${props => props.theme.spacing[3]};
`;

const Unauthorized = ({ history }) => {
  const handleButtonClick = () => {
    history.push(getInternalPath({ pathName: DASHBOARD_PATH }));
  };

  return (
    <StyledUnauthorizedWrapper>
      <StyledHeading>Sorry, you don’t have permission to view this page</StyledHeading>
      <StyledDescription>We’re sorry for the inconvenience, but you don’t have permission to visit this page. Your user role may have been changed. If you believe this is an error, please contact an Admin or your account director.</StyledDescription>
      <Button
        onClick={handleButtonClick}
      >
        Back To Dashboard
      </Button>
    </StyledUnauthorizedWrapper>
  );
};

Unauthorized.propTypes = {
  history: PropTypes.object,
};

Unauthorized.defaultProps = {
  history: {},
};

export default Unauthorized;
